export enum WazzupCreationCaseId {
  noAccount = 'noAccount',
  noCRM = 'noCRM',
  withAccountAndCRM = 'withAccountAndCRM'
}
